import { FadeConfig } from './CustomCategoryFade.types';

export const FADE_BACKGROUND = 'screenBackground';

export const FADE_CONFIG: FadeConfig = {
  top: {
    style: {
      top: 'space-0',
      left: 'space-0',
      right: 'space-0',
      height: {
        mobile: 'space-800',
        tablet: 'space-1000',
        desktop: 'space-1200',
      },
    },
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
  },
  right: {
    style: {
      top: 'space-0',
      right: 'space-0',
      bottom: 'space-0',
      width: {
        mobile: 'space-800',
        tablet: 'space-1000',
        desktop: 'space-1200',
      },
    },
    start: { x: 1, y: 0 },
    end: { x: 0, y: 0 },
  },
  bottom: {
    style: {
      left: 'space-0',
      right: 'space-0',
      bottom: 'space-0',
      height: {
        mobile: 'space-800',
        tablet: 'space-1000',
        desktop: 'space-1200',
      },
    },
    start: { x: 0, y: 1 },
    end: { x: 0, y: 0 },
  },
};
